import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Drawer from '@mui/material/Drawer';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import AddIcon from '@mui/icons-material/Add';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MainStore from '../../../MainStore';
import SchedulleStore from '../Scheduller/SchedulleStore';
import { observer } from 'mobx-react';
import AuthStore from '../../Auth/AuthStore';
import ProjectSelect from './ProjectSelect';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import TabUnselectedIcon from '@mui/icons-material/TabUnselected';
import Tooltip from '@mui/material/Tooltip';
import './projects.css'

const ProjectTimeMenu = observer(class ProjectTimeMenu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            projects: [],
            isOpen: false,
            name: '',
            color: '',
            id: '',
            filterProjectIds: []
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.loadProjects = this.loadProjects.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.generateProjectCards = this.generateProjectCards.bind(this);
        this.unselectAll = this.unselectAll.bind(this);
        this.selectAll = this.selectAll.bind(this);
    }

    componentDidMount() {
        this.loadProjects();
    }

    handleInputChange(e) {
        this.setState({ name: e.target.value }, () => this.loadProjects());
    }

    loadProjects(v) {
        var scope = this;
        var token = localStorage.getItem("token");
        fetch('api/Project/GetActiveProjects?name=' + this.state.name, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ projects: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleClear() {
        this.setState({ name: '', id: '', isOpen: false });
    }

    handleOpen(e) {
        this.setState({ isOpen: true });
        this.loadProjects('');
    }

    handleProjectClick = project => () => {
        var projectIds = MainStore.getFilterProjectIds.slice();
        var index = projectIds.findIndex(p => p === project.id);
        if (index > -1) {
            projectIds.splice(index, 1);
            MainStore.setFilterProjectIds(projectIds);
        }
        else {
            projectIds.push(project.id);
            MainStore.setFilterProjectIds(projectIds);
        }
    }

    handleTimeChange = project => () =>  {
        SchedulleStore.openSchedulleEditDialog({ projectId: project.id, date: new Date(), workNumber: project.name, workCaption: ''}, '');
    }

    selectAll() {
        let projects = this.state.projects;
        let projectIds = MainStore.getFilterProjectIds.slice();

        projects.forEach(project => {
            let index = projectIds.findIndex(p => p === project.id);
            if (index === -1) {
                projectIds.push(project.id);
            }
        });
        MainStore.setFilterProjectIds(projectIds);
    }

    unselectAll() {
        MainStore.setFilterProjectIds([]);
    }

    handleDrawerClose() {
        MainStore.setIsProjectDrawerVisible(false);
    }

    generateProjectCards() {
        return (
            <div className={"project-chip-block clearfix " + this.props.className}>
                {this.state.projects.map(p => <div key={p.id} className="project-time-item"><Chip
                    size="small"
                    label={p.name}
                    avatar={<Avatar>{p.count}</Avatar>}
                    onClick={this.handleProjectClick(p)}
                    color={MainStore.getFilterProjectIds.findIndex(fp => fp === p.id) > -1 ? "secondary" : "primary"}
                    className="project-chip"
                    onDelete={this.handleTimeChange(p)}
                    deleteIcon={<div className="watch drawer-watch" />}
                /></div>)}
            </div>);
    }

    render() {

        return (
            <Drawer
                variant="persistent"
                anchor="left"
                open={MainStore.getIsProjectDrawerVisible}
            >
                <div>
                    <IconButton onClick={this.handleDrawerClose} size="large">
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />
                <FormControl>
                    <InputLabel htmlFor="project-required">{this.props.label}</InputLabel>
                    <Input required
                        id="project-required"
                        type='text'
                        label={this.props.label}
                        fullWidth
                        margin="none"
                        value={this.state.name}
                        onChange={this.handleInputChange}
                        autoComplete='off'
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    onClick={this.handleClear}
                                    size="large">
                                    x
                                </IconButton>
                            </InputAdornment>
                        }
                    />
                </FormControl>
                <div>
                    <Tooltip title="Выбрать все">
                        <IconButton onClick={this.selectAll} size="large">
                            <SelectAllIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Очистить фильтр">
                        <IconButton onClick={this.unselectAll} size="large">
                            <TabUnselectedIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <div style={{ "overflow": "auto" }}>
                    {this.generateProjectCards()}
                </div>
            </Drawer>
        );
    }
})
export default ProjectTimeMenu;